import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 32px;
  background: linear-gradient(180deg, #1e3a8a 0%, #3954acff 100%);
  color: white;
  text-align: center;
`;

const IconWrapper = styled.div`
  font-size: 50px;
  margin-bottom: 24px;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 16px;
`;


const Button = styled.button`
  background: white;
  color: #1e40af;
  border: none;
  padding: 16px 32px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  transition: transform 0.2s;
  position: relative;
  z-index: 10;

  &:active {
    transform: scale(0.98);
  }
`;

interface ClosingSlideProps {
  onRestart: () => void;
  onClose: () => void;
}

const CTAButton = styled(Button)`
  background: #2563eb;
  color: white;
  font-weight: 700;
  border: none;
  margin-top: 12px;
  
  &:hover {
    background: #1d4ed8;
  }
`;


const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Subtitle = styled.p`
  font-size: 18px;
  line-height: 1.6;
  opacity: 0.9;
  max-width: 320px;
  margin-bottom: 24px;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const ClosingSlide: React.FC<ClosingSlideProps> = ({ onRestart, onClose }) => {
  return (
    <Container onClick={onClose}>

      <Content>
        <IconWrapper>🌟</IconWrapper>
        <Title>¡Gracias por ser parte de este año!</Title>
        <Subtitle>
          Tu historia financiera es única y en el 2026 estaremos aquí para
          acompañarte a alcanzar todas tus metas.
        </Subtitle>
      </Content>

      <Footer>
        <Button onClick={(e) => {
          e.stopPropagation();
          onRestart();
        }}>
          Ver de nuevo ↺
        </Button>
        <Link to="/plan-consultas" onClick={(e: React.MouseEvent) => e.stopPropagation()}>
          <CTAButton>
            Actualizar mi consulta
          </CTAButton>
        </Link>


        <div
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          style={{
            marginTop: '16px',
            fontSize: '14px',
            color: 'rgba(255,255,255,0.7)',
            textDecoration: 'underline',
            cursor: 'pointer',
            zIndex: 10,
            position: 'relative'
          }}
        >
          Volver al inicio
        </div>
      </Footer>
    </Container>
  );
};

export default ClosingSlide;
